"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPickupOrder = exports.isOrder = exports.addressSchema = void 0;
var yup = require("yup");
var OrderStatusLogEntry_1 = require("./OrderStatusLogEntry");
exports.addressSchema = yup.object().shape({
    postalCode: yup.string().optional(),
    streetAdress1: yup.string().optional(),
    streetAdress2: yup.string().optional(),
    phone: yup.string().optional(),
    city: yup.string().optional(),
    contry: yup.string().optional(),
    firstName: yup.string().optional(),
    lastName: yup.string().optional(),
});
var orderSchema = yup.object().shape({
    id: yup.string().required(),
    onfleetTaskId: yup.string().optional(),
    onfleetWorkerId: yup.string().optional(),
    onfleetTrackingUrl: yup.string().optional(),
    onfleetWorkerLocation: yup
        .object({
        latitude: yup.number().required(),
        longitude: yup.number().required(),
    })
        .default(undefined),
    shopifyCustomerId: yup.number().optional(),
    shopifyOrderId: yup.number().optional(),
    saleorUserId: yup.string().required(),
    saleorOrderId: yup.string().required(),
    isPicked: yup.boolean().optional(),
    statusLog: yup.array().of(OrderStatusLogEntry_1.orderStatusLogEntrySchema).min(1).required(),
    estimatedArrivalTime: yup.number().optional(),
    createdAt: yup.number().required(),
    deliveryTime: yup.number().optional(),
    promisedDeliveryTime: yup.number().optional(),
    warehouseId: yup.string().required(),
    deliveryAddress: exports.addressSchema.optional(),
    shippingMethod: yup.string().optional(),
    fulfillmentStatus: yup.string().optional(),
    appVersion: yup.string().optional(),
    pickingStatus: yup.string().optional(),
});
function isOrder(obj) {
    return orderSchema.isValidSync(obj);
}
exports.isOrder = isOrder;
var isPickupOrder = function (order) {
    return (order === null || order === void 0 ? void 0 : order.shippingMethod) === "Pickup";
};
exports.isPickupOrder = isPickupOrder;
